import { createApiClient } from './ApiClientFactory.js'

const baseURL = import.meta.env.VITE_BASE_URL
const apiClient = createApiClient(`${baseURL}/orders`)

export default {
  async getOrders(params = {}) {
    const response = await apiClient.get('/', { params })
    return response.data
  },

  async getOrder(id) {
    const response = await apiClient.get(`/${id}`)
    return response.data
  },

  async createOrder(order) {
    const response = await apiClient.post('/', order)
    return response.data
  },

  async updateOrder(id, order) {
    const response = await apiClient.put(`/${id}`, order)
    return response.data
  },

  async deleteOrder(id) {
    const response = await apiClient.delete(`/${id}`)
    return response.data
  },

  async addActivity(id, { title, description }) {
    const response = await apiClient.post(`/${id}/activity`, { title, description })
    return response.data
  },
}